<template>
<BModal :model-value="modal" scrollable size="lg" centered title="Detail" @update:modelValue="updateModal">
    <!-- <BTable :items="dataDetail"></BTable> -->
     <DataTable :data="dataDetail"></DataTable>
</BModal>
</template>

<script>

import { BModal} from 'bootstrap-vue-next'
import DataTable from '@/components/DataTable.vue';



export default{
    name : 'PackageDetail',
    components : { BModal, DataTable },
    props : {
        modal : Boolean,
        dataDetail : Array,
    },

    
    setup(props, { emit }){

        const updateModal = (value)=>{
            emit("update:modal", value);
        }
        return{
            updateModal,
        }
    }
}
</script>